<template>
  <div :class="formGroupClass">
    <validation-provider
      :name="labelName ? labelName.toLowerCase() : label.toLowerCase()"
      :rules="rules"
      v-slot="validationContext"
    >
      <label v-if="label">
        {{ label }}
        <span class="required-indc" v-if="field && field.required"> * </span>
        <span class="semi-label" v-if="semiLabel">{{ semiLabel }}</span>
      </label>
      <div class="input-icon">
        <input
          :id="field.field_name"
          :type="type"
          :class="
            (apiErrors && apiErrors[field.field_name]) ||
            validationContext.errors[0]
              ? `error-input reg-field ${inputClass}`
              : `reg-field ${inputClass}`
          "
          v-if="field && field.field_name"
          :placeholder="placeholder"
          :disabled="field && field.readOnly"
          v-model="form[field.field_name]"
          @input="inputHandler"
          :state="getValidationState(validationContext)"
        />
        <slot name="appendIcon" />
      </div>
      <slot name="shortMessage" />
      <error-text
        v-if="
          (apiErrors && apiErrors[field.field_name]) ||
          validationContext.errors[0]
        "
        :errors="
          apiErrors
            ? apiErrors
            : validationContext.errors
            ? validationContext.errors
            : ''
        "
        :field="field.field_name"
      />
    </validation-provider>
  </div>
</template>
<script>
export default {
  name: "RegInputText",
  props: {
    apiErrors: {
      required: false,
    },
    form: {
      required: true,
    },
    field: {
      required: true,
    },
    label: {
      required: true,
    },
    placeholder: {
      required: false,
    },
    formGroupClass: {
      required: false,
      default: "col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4",
    },
    type: {
      required: false,
      default: "text",
    },
    rules: {
      type: Object,
      required: false,
      default: null,
    },
    labelName: {
      required: false,
    },
    semiLabel: {
      type: String,
      required: false,
    },
    inputClass: {
      required: false,
      default: "",
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      if (this.rules) {
        return dirty || validated ? valid : null;
      }
      return null;
    },
    inputHandler() {
      this.$emit("inputHandler");
    },
  },
};
</script>